var _rect, _rect2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpanishIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.42773,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5915_266590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3.42773,
    width: 24,
    height: 17.1429,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5915_266590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.99916H24V3.42773H0V7.99916Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.5714H24V16H0V20.5714Z",
    fill: "#DD172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H24V8H0V16Z",
    fill: "#FFD133"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28613 11.4277H7.42899V11.9992H6.28613V11.4277Z",
    fill: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62753 12.0731C5.60281 11.7765 5.83687 11.5221 6.1345 11.5221H6.43681C6.73443 11.5221 6.96849 11.7765 6.94378 12.0731L6.85906 13.0898C6.83421 13.388 6.58491 13.6174 6.28565 13.6174C5.9864 13.6174 5.7371 13.388 5.71225 13.0898L5.62753 12.0731Z",
    stroke: "#A41517",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14258 12H7.42829V12.5714H6.85686L6.28544 13.7143L5.71401 12.5714H5.14258V12Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.42871,
    y: 10.2852,
    width: 1.14286,
    height: 4,
    rx: 0.571429,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10.2852,
    width: 1.14286,
    height: 4,
    rx: 0.571429,
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14258 10.0569C5.14258 9.55192 5.55192 9.14258 6.05686 9.14258H6.51401C7.01895 9.14258 7.42829 9.55192 7.42829 10.0569C7.42829 10.1831 7.32596 10.2854 7.19972 10.2854H5.37115C5.24491 10.2854 5.14258 10.1831 5.14258 10.0569Z",
    fill: "#A41517"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanishIcon);
export default __webpack_public_path__ + "static/media/spanish-icon.99cdff147c9f8243b20f39c11119d692.svg";
export { ForwardRef as ReactComponent };